{
  "schemaVersion": "1.0",
  "researchAsOf": "2026-07-15",
  "recordCount": 133,
  "voivodeshipsTotal": 16,
  "voivodeshipsWithOfficialSourceRoute": 16,
  "voivodeshipsWithNormalizedRecords": 2,
  "normalizedRecordCounts": {
    "łódzkie": 87,
    "świętokrzyskie": 46
  },
  "recordsByStatus": {
    "active": 87,
    "pending_confirmation": 46
  },
  "currentOfficialRegistersFullyNormalized": [
    "łódzkie"
  ],
  "staleOfficialRegistersFullyNormalized": [
    "świętokrzyskie"
  ],
  "currentRegisterReconciliationCompleteCount": 1,
  "unresolvedCurrentSourcesCount": 15,
  "nationalCompletenessClaim": false,
  "sourceStatusCounts": {
    "stale": 6,
    "unknown": 3,
    "unresolved": 2,
    "aging": 3,
    "current": 1,
    "content_mismatch": 1
  },
  "gusBaseline": {
    "sourceAsOf": "2025-12-31",
    "publicationDate": "2026-04-23",
    "familyCareArrangements": 37747,
    "familyCareChildren": 60748,
    "institutionalFacilities": 1328,
    "institutionalResidents": 17519,
    "totalChildren": 78267
  },
  "reconciliation": [
    {
      "voivodeship": "dolnośląskie",
      "gusInstitutionalFacilities2025": 153,
      "registerCount": null,
      "deltaRegisterMinusGus": null,
      "registerSourceAsOf": "2024-12-31",
      "status": "not_reconciled",
      "explanation": "No safely parsed official register count was available for comparison."
    },
    {
      "voivodeship": "kujawsko-pomorskie",
      "gusInstitutionalFacilities2025": 95,
      "registerCount": null,
      "deltaRegisterMinusGus": null,
      "registerSourceAsOf": null,
      "status": "not_reconciled",
      "explanation": "No safely parsed official register count was available for comparison."
    },
    {
      "voivodeship": "lubelskie",
      "gusInstitutionalFacilities2025": 91,
      "registerCount": null,
      "deltaRegisterMinusGus": null,
      "registerSourceAsOf": null,
      "status": "not_reconciled",
      "explanation": "No safely parsed official register count was available for comparison."
    },
    {
      "voivodeship": "lubuskie",
      "gusInstitutionalFacilities2025": 42,
      "registerCount": null,
      "deltaRegisterMinusGus": null,
      "registerSourceAsOf": "2025-10-30",
      "status": "not_reconciled",
      "explanation": "No safely parsed official register count was available for comparison."
    },
    {
      "voivodeship": "łódzkie",
      "gusInstitutionalFacilities2025": 85,
      "registerCount": 87,
      "deltaRegisterMinusGus": 2,
      "registerSourceAsOf": "2026-07-01",
      "status": "reconciled_current_source",
      "explanation": "Register is dated 2026-07-01 while GUS is a 2025-12-31 stock; openings, closures, permits, and GUS statistical scope can create a difference."
    },
    {
      "voivodeship": "małopolskie",
      "gusInstitutionalFacilities2025": 94,
      "registerCount": null,
      "deltaRegisterMinusGus": null,
      "registerSourceAsOf": null,
      "status": "not_reconciled",
      "explanation": "No safely parsed official register count was available for comparison."
    },
    {
      "voivodeship": "mazowieckie",
      "gusInstitutionalFacilities2025": 140,
      "registerCount": null,
      "deltaRegisterMinusGus": null,
      "registerSourceAsOf": null,
      "status": "not_reconciled",
      "explanation": "No safely parsed official register count was available for comparison."
    },
    {
      "voivodeship": "opolskie",
      "gusInstitutionalFacilities2025": 31,
      "registerCount": null,
      "deltaRegisterMinusGus": null,
      "registerSourceAsOf": "2025-11-30",
      "status": "not_reconciled",
      "explanation": "No safely parsed official register count was available for comparison."
    },
    {
      "voivodeship": "podkarpackie",
      "gusInstitutionalFacilities2025": 46,
      "registerCount": null,
      "deltaRegisterMinusGus": null,
      "registerSourceAsOf": null,
      "status": "not_reconciled",
      "explanation": "No safely parsed official register count was available for comparison."
    },
    {
      "voivodeship": "podlaskie",
      "gusInstitutionalFacilities2025": 33,
      "registerCount": null,
      "deltaRegisterMinusGus": null,
      "registerSourceAsOf": "2025-10-15",
      "status": "not_reconciled",
      "explanation": "No safely parsed official register count was available for comparison."
    },
    {
      "voivodeship": "pomorskie",
      "gusInstitutionalFacilities2025": 85,
      "registerCount": 83,
      "deltaRegisterMinusGus": -2,
      "registerSourceAsOf": "2025-01-14",
      "status": "stale_count_only",
      "explanation": "Register predates the 2025-12-31 GUS stock; timing and statistical/register scope differ, so equality is not forced."
    },
    {
      "voivodeship": "śląskie",
      "gusInstitutionalFacilities2025": 179,
      "registerCount": null,
      "deltaRegisterMinusGus": null,
      "registerSourceAsOf": null,
      "status": "not_reconciled",
      "explanation": "No safely parsed official register count was available for comparison."
    },
    {
      "voivodeship": "świętokrzyskie",
      "gusInstitutionalFacilities2025": 47,
      "registerCount": 46,
      "deltaRegisterMinusGus": -1,
      "registerSourceAsOf": "2025-05-21",
      "status": "stale_records_extracted",
      "explanation": "Register predates the 2025-12-31 GUS stock; timing and statistical/register scope differ, so equality is not forced."
    },
    {
      "voivodeship": "warmińsko-mazurskie",
      "gusInstitutionalFacilities2025": 71,
      "registerCount": null,
      "deltaRegisterMinusGus": null,
      "registerSourceAsOf": "2024-10-04",
      "status": "not_reconciled",
      "explanation": "No safely parsed official register count was available for comparison."
    },
    {
      "voivodeship": "wielkopolskie",
      "gusInstitutionalFacilities2025": 71,
      "registerCount": null,
      "deltaRegisterMinusGus": null,
      "registerSourceAsOf": "2024-11-12",
      "status": "not_reconciled",
      "explanation": "No safely parsed official register count was available for comparison."
    },
    {
      "voivodeship": "zachodniopomorskie",
      "gusInstitutionalFacilities2025": 65,
      "registerCount": null,
      "deltaRegisterMinusGus": null,
      "registerSourceAsOf": "2023-04-03",
      "status": "not_reconciled",
      "explanation": "No safely parsed official register count was available for comparison."
    }
  ],
  "unresolvedSources": [
    {
      "voivodeship": "dolnośląskie",
      "freshnessStatus": "stale",
      "parseStatus": "binary_unavailable",
      "gap": "Archived BIP page; the current gov.pl route was found, but no newer public master-register attachment was resolved."
    },
    {
      "voivodeship": "kujawsko-pomorskie",
      "freshnessStatus": "unknown",
      "parseStatus": "binary_unavailable",
      "gap": "Official attachment is undated and appears old; currentness could not be established."
    },
    {
      "voivodeship": "lubelskie",
      "freshnessStatus": "unresolved",
      "parseStatus": "landing_only",
      "gap": "Official child page timed out and no current attachment locator was recoverable."
    },
    {
      "voivodeship": "lubuskie",
      "freshnessStatus": "aging",
      "parseStatus": "binary_unavailable",
      "gap": "Newest located official attachment; binary body was not retrievable in the research environment."
    },
    {
      "voivodeship": "małopolskie",
      "freshnessStatus": "unknown",
      "parseStatus": "binary_unavailable",
      "gap": "Landing page exposes four type-specific DOC files, but dates/currentness and binary contents were unavailable. Additional files: Typu_Interwencyjnego.doc, Typu_Rodzinnego.doc, Typu_Specjalistyczno_Terapeutycznego.doc."
    },
    {
      "voivodeship": "mazowieckie",
      "freshnessStatus": "unknown",
      "parseStatus": "binary_unavailable",
      "gap": "Official current landing and attachment locator found; no source-as-of date was exposed and the workbook body was unavailable."
    },
    {
      "voivodeship": "opolskie",
      "freshnessStatus": "content_mismatch",
      "parseStatus": "not_parsed",
      "gap": "Page updated 2025-12-23, but the visible attachment is a November vacancy report rather than a stable master register."
    },
    {
      "voivodeship": "podkarpackie",
      "freshnessStatus": "aging",
      "parseStatus": "binary_unavailable",
      "gap": "Official July 2025 upload found; exact register date and document body were unavailable."
    },
    {
      "voivodeship": "podlaskie",
      "freshnessStatus": "aging",
      "parseStatus": "binary_unavailable",
      "gap": "Official attachment name identifies the register date; document body was unavailable."
    },
    {
      "voivodeship": "pomorskie",
      "freshnessStatus": "stale",
      "parseStatus": "count_only",
      "gap": "Official PDF rendered, and register positions 1–83 were observed. Column order was scrambled in text extraction, so no facility rows were normalized safely."
    },
    {
      "voivodeship": "śląskie",
      "freshnessStatus": "unresolved",
      "parseStatus": "landing_unreachable",
      "gap": "Legacy official locator was unreachable and no current official replacement was established."
    },
    {
      "voivodeship": "świętokrzyskie",
      "freshnessStatus": "stale",
      "parseStatus": "parsed_pdf",
      "gap": "All 46 rendered register rows were normalized. Staleness and two visible source anomalies are retained in each affected record."
    },
    {
      "voivodeship": "warmińsko-mazurskie",
      "freshnessStatus": "stale",
      "parseStatus": "binary_unavailable",
      "gap": "Page was updated in 2025 but still exposes a workbook named for 4 October 2024."
    },
    {
      "voivodeship": "wielkopolskie",
      "freshnessStatus": "stale",
      "parseStatus": "binary_unavailable",
      "gap": "Official direct PDF found; no newer parent-page attachment was resolved."
    },
    {
      "voivodeship": "zachodniopomorskie",
      "freshnessStatus": "stale",
      "parseStatus": "landing_unreachable",
      "gap": "Legacy official route timed out; the current attachment remains unresolved."
    }
  ],
  "knownLimitations": [
    "Only Łódzkie is reconciled to a current official register. Nationwide completeness is not established.",
    "Świętokrzyskie records are official but dated 2025-05-21 and therefore are not asserted to remain active.",
    "Pomorskie yielded a register count of 83 but not reliably aligned row fields; no partial records were emitted.",
    "Binary DOC, DOCX, XLS, XLSX, and several PDF attachments could not be retrieved in the research environment.",
    "No operator or permit values were inferred when an official rendered table did not expose them.",
    "GUS facility counts and voivodeship registers have different dates and potentially different inclusion rules."
  ]
}
